import React, { useMemo, useState, useEffect } from "react";

import { getDefaultDateRange, getISOTime } from "utils/helpers";
import { Spacer } from "components/base/Spacer";
import PaymentsListFilter from "./PaymentsListFilter";
import PaymentsListTable from "./PaymentsListTable";


export default ({
    paymentItems,
    paymentItemsLoading,
    getPaymentList,
    accounts
}) => {

    const { start: dateStart, end: dateEnd } = useMemo(() => getDefaultDateRange(6), []);

    const [filters, setFilters] = useState({
        start_end_date: [dateStart, dateEnd],
        account_id_list: null
    });

    useEffect(() => {
        const data = {
            target: {
                account_id_list: null
            },
            filter: {
                start_date: getISOTime(dateStart),
                end_date: getISOTime(dateEnd),
            }
        };
        getPaymentList(data);
    }, []);

    const handleChangeFilters = (value) => {
        if (!value || !value.start_end_date || !value.start_end_date[0] || !value.start_end_date[1]) {
            return;
        }

        const accountIdList = value.account_id_list !== undefined ? value.account_id_list : [];

        setFilters({
            start_end_date: value.start_end_date,
            account_id_list: accountIdList
        });

        const [start, end] = value.start_end_date;

        const startDate = new Date(start);
        startDate.setHours(0, 0, 0, 0);

        const endDate = new Date(end);
        endDate.setHours(23, 59, 59, 999);

        const normalizedRange = [startDate, endDate];

        const filterData = {
            start_date: getISOTime(startDate),
            end_date: getISOTime(endDate),
            start_end_date: normalizedRange
        };

        getPaymentList({
            target: {
                account_id_list: accountIdList.length ? accountIdList : null
            },
            filter: filterData
        });
    };

    return (
        <>
            <PaymentsListFilter
                accounts={accounts}
                filters={filters}
                onChangeFilters={handleChangeFilters}
            />

            <Spacer />

            <PaymentsListTable
                withFilters
                data={paymentItems}
                height={700}
                loading={paymentItemsLoading}
            />
        </>
    );
};